import React, { useEffect, useState } from 'react';

import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import MuiTableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import MuiTableRow from '@mui/material/TableRow';

import Grid from '@mui/material/Grid';
import Dialog from '@mui/material/Dialog';
import MuiDialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Pagination from '@mui/material/Pagination';

// Icons
import CloseIcon from '@mui/icons-material/Close';
import HistoryIcon from '@mui/icons-material/History';

import { utils } from '../../../utils/utils';
import orderHistoryService from '../../../services/orderHistoryService';
import useNotify from '../../../hooks/notify';
import { Spinner } from '@arredo/reactjs-ui';

const DialogTitleRoot = styled('div')(({ theme }) => ({
    margin: 0, 
    padding: theme.spacing(2)
}));

const CloseButton =  styled(IconButton)(({ theme }) => ({
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500]
}));

const TableCell = styled(MuiTableCell)(({ theme }) => ({
    '&.MuiTableCell-head': {
        backgroundColor: theme.palette.grey[700],
        color: theme.palette.common.white,
        fontSize: 14
    }
}));

const TableRow = styled(MuiTableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover
    }
}));

const DialogTitle = ({children, onClose, ...other }) => (
        <DialogTitleRoot {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose && (
                <CloseButton onClick={onClose} aria-label="close" size="large">
                     <CloseIcon />
                </CloseButton>
            )}      
        </DialogTitleRoot>
);

export const HistoryButton = ({ orderId }) => {
    const [open, setOpenHistory] = useState(false);

    const handleClose = () =>
        setOpenHistory(false);

    return (
        <>
            <Tooltip title='Historial' aria-label='Editar'>
                <IconButton onClick={() => setOpenHistory(true)} color='primary' size="large">
                    <HistoryIcon color='primary' />
                </IconButton>
            </Tooltip>
            {open &&
                <HistoryModal
                    orderId={orderId}
                    open={open}
                    onClose={handleClose}
                />
            }
        </>
    );
}

const HistoryModal = ({ orderId, open, onClose }) => {
    const { Notify, variants } = useNotify()
    const [loading, setLoading] = useState(false);
    const [{ history, totalPage }, setHistory] = useState({
        history: [],
        totalPage: 0,
        totalResults: 0
    });

    const [filters, setFilters] = useState({ pageSize: 6, pageNumber: 1 });

    useEffect(() => {
        const searchHistory = () => {
            setLoading(true);
            orderHistoryService
                .Search({ ...filters, orderId })
                .then(res => setHistory({
                    history: res.values,
                    totalPage: res.totalPage,
                    totalResults: res.totalResults
                }))
                .catch(err => Notify(err.message, variants.ERROR))
                .finally(() => setLoading(false))
        }

        if (orderId)
            searchHistory();
    }, [orderId, filters, Notify, variants]);

    const handleChangePage = (e, page) =>
        setFilters({ ...filters, pageNumber: Number(page) });

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth='md'
        >
            <DialogTitle onClose={onClose}>
                Historial
            </DialogTitle>
            <DialogContent dividers>
                {
                    loading &&
                    <Spinner lockScreen />
                }
                <Grid container spacing={1} justifyContent='center'>
                    <Grid size={12}>
                        <TableContainer component={Paper}>
                            <Table aria-label="a dense table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Detalle</TableCell>
                                        <TableCell align="right">Creado</TableCell>
                                        <TableCell align="right">Usuario</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        history.map((row, index) => (
                                            <TableRow key={index}>
                                                <TableCell component="th" scope="row">
                                                    {row.detail}
                                                </TableCell>
                                                <TableCell align="right">{utils.formatDate(row.created)}</TableCell>
                                                <TableCell align="right">{row.user}</TableCell>
                                            </TableRow>
                                        ))
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                    <Grid>
                        <Pagination
                            color='primary'
                            count={totalPage}
                            page={filters?.pageNumber || 1}
                            onChange={handleChangePage}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    );
}

export default HistoryModal;